/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceListingResponse {
    getFixupPrototypeFunction() { return ResourceListingResponse.fixupPrototype; }

    static newInstance(model: Partial<ResourceListingResponse>): ResourceListingResponse {
        let obj = Object.assign(new ResourceListingResponse(), model);
        ResourceListingResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceListingResponse>): ResourceListingResponse {
        if (!model) return null;
        return ResourceListingResponse.newInstance(<ResourceListingResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceListingResponse) {
        if (!obj) return;

        models.ResourceListingResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceListingResponse): boolean {
        Object.setPrototypeOf(obj, ResourceListingResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the resources
     */
    id: string;

    /**
     * Name of the resource
     */
    name: string;

}
